import { jsx as _jsx } from "react/jsx-runtime";
const SvgLink = (props) => (_jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: _jsx("path", { d: "M1.626.36v2h8.59l-9.59 9.59 1.41 1.41 9.59-9.59v8.59h2v-12h-12Z", fill: "currentColor" }) }));
export default SvgLink;
